import type { AudioDevice } from '../hooks/useAudioCapture';
import { t } from '../i18n';

interface Props {
  devices: AudioDevice[];
  selectedDeviceId: string | null;
  isCapturing: boolean;
  onSelect: (deviceId: string) => void;
  onRefresh: () => void;
}

export default function MicSelector({
  devices,
  selectedDeviceId,
  isCapturing,
  onSelect,
  onRefresh,
}: Props) {
  return (
    <div className="card">
      <div className="card-title">{t('マイク選択', 'Microphone')}</div>
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <select
          className="input-text"
          value={selectedDeviceId ?? ''}
          onChange={(e) => onSelect(e.target.value)}
          disabled={isCapturing}
          style={{ flex: 1 }}
        >
          {devices.length === 0 ? (
            <option value="">{t('— マイクが見つかりません —', '— No microphone found —')}</option>
          ) : (
            devices.map((d) => (
              <option key={d.deviceId} value={d.deviceId}>
                {d.label}
              </option>
            ))
          )}
        </select>
        <button
          className="btn btn-ghost btn-sm"
          onClick={onRefresh}
          title={t('デバイス一覧を更新', 'Refresh device list')}
          type="button"
        >
          🔄
        </button>
      </div>

      {devices.length === 0 && (
        <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
          {t('「🔄」を押してマイクを検索してください', 'Press 🔄 to search for microphones')}
        </p>
      )}
    </div>
  );
}
